<template>
	<div id="reset-form">
		<el-form :model="ruleForm" :rules="rules" :label-position="labelPosition" ref="ruleForm" label-width="100px" class="ruleForm">
		  <el-form-item label="Email" prop="email">
		    <el-input v-model="ruleForm.email"></el-input>
		  </el-form-item>
		  <el-form-item>
		    <el-button @click="submitForm('ruleForm')">Reset password</el-button>
		    <router-link to="/" class="alt-link">Back to Login</router-link>
		  </el-form-item>
		</el-form>
	</div>
</template>
<script>
import { authService } from '../helpers/helpers'
export default {
  data () {
    return {
      auth: authService,
      labelPosition: 'top',
      ruleForm: {
        email: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please enter your email address', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.auth.reset(this.ruleForm.email)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style>

	#reset-form {
		display: flex;
		align-items: center;
		min-height: 24em;
		justify-content: center;
	}

	#reset-form .el-form {
		flex: 1;
		max-width: 380px;
		padding:  0 30px;
	}

	.ruleForm {
		text-align: left;
	}

</style>


// WEBPACK FOOTER //
// Reset.vue?d44313fe